import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import EconomicActivity from "../../models/economic-activity";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";

interface EconomicActivityDeleteModalProps {
  show: boolean;
  economicActivity?: EconomicActivity;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const EconomicActivityDeleteModal: React.FC<
  EconomicActivityDeleteModalProps
> = ({ show, economicActivity, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = economicActivity
    ? `Está seguro de que quiere eliminar la actividad ${economicActivity.description}`
    : "";

  const onDeleteClick = async () => {
    if (economicActivity !== undefined) {
      setSubmitting(true);
      const economicActivityStatus = await deleteItem(
        `/economic_activities/${economicActivity.id}/`,
        economicActivity
      );

      if (economicActivityStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (economicActivityStatus.detail !== undefined) {
          message = economicActivityStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default EconomicActivityDeleteModal;
